import React, { createContext, useContext, useState, useCallback } from 'react';
import FileViewer from './FileViewer';

interface FileViewerFile {
  /** CRM file_object id — mutually exclusive with directUrl */
  fileId?: number;
  /** Direct URL (e.g. Google Drive preview) — skip signed URL fetch */
  directUrl?: string;
  filename: string;
  mimeType?: string;
}

interface FileViewerContextValue {
  openFile: (file: FileViewerFile) => void;
  closeFile: () => void;
}

const FileViewerContext = createContext<FileViewerContextValue>({
  openFile: () => {},
  closeFile: () => {},
});

export function useFileViewer() {
  return useContext(FileViewerContext);
}

export function FileViewerProvider({ children }: { children: React.ReactNode }) {
  const [file, setFile] = useState<FileViewerFile | null>(null);

  const openFile = useCallback((f: FileViewerFile) => setFile(f), []);
  const closeFile = useCallback(() => setFile(null), []);

  return (
    <FileViewerContext.Provider value={{ openFile, closeFile }}>
      {children}
      {file && (
        <FileViewer
          fileId={file.fileId}
          directUrl={file.directUrl}
          filename={file.filename}
          mimeType={file.mimeType}
          onClose={closeFile}
        />
      )}
    </FileViewerContext.Provider>
  );
}
